var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Reanudar Factura"}},[_c('seccionReanudarVue',{staticClass:"mt-2"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }